var _interface = require('util/interface').interface;

/**
 * Diffusion datatype implementations.
 * <P>
 * Datatypes are accessed via the <code>diffusion</code> singleton.
 *
 * @example
 * // Get the JSON datatype
 * var json = diffusion.datatypes.json();
 *
 * @example
 * // Get a datatype via name
 * var json = diffusion.datatypes.get('json');
 *
 * @namespace diffusion.datatypes
 * @since 5.7
 */
module.exports = _interface('DataTypes', [
    /**
     * @return {diffusion.datatypes.BinaryDataType} The Binary data type
     * @function diffusion.datatypes#binary
     */
    'binary',

    /**
     * @return {diffusion.datatypes.JSONDataType} The JSON data type
     * @function diffusion.datatypes#json
     */
    'json',

    /**
     * Obtain a {@link diffusion.datatypes.DataType} implementation by type name.
     *
     * @param {String} name - The type name, as returned by {@link diffusion.datatypes.DataType#getTypeName}.
     * @return {diffusion.datatypes.DataType} The data type
     * @throws Error if there is no data type for provided name
     * @function diffusion.datatypes#get
     */
    'get'
]);



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/data/datatypes.js
// module id = 985
// module chunks = 1